/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export const DEFAULT_PARAMETER: PropertyTypeParameter = {"value": null, "displayValue": ""};

export const BOOLEAN_PARAMETERS: PropertyTypeParameter[] = 
  [
    {"value": "1", "displayValue": "True / False"},
    {"value": "2", "displayValue": "Yes / No"},
    {"value": "3", "displayValue": "Checkbox"}
  ];

export const STRING_PARAMETERS: PropertyTypeParameter[] = 
  [
    {"value": "1", "displayValue": "Normal String"},
    {"value": "2", "displayValue": "IP Address"},
    {"value": "3", "displayValue": "Text Area"},
    {"value": "url", "displayValue": "URL"}
  ];

export const COLOR_PARAMETERS: PropertyTypeParameter[] = 
  [
    {"value": "1", "displayValue": "Color Picker"},
    {"value": "2", "displayValue": "R/G/B"},
  ];

export const INTEGER_PARAMETERS: PropertyTypeParameter[] = 
  [
    {"value": "1", "displayValue": "Integer (No decimals)"},
    {"value": "2", "displayValue": "Large Integer (No decimals)"},
    {"value": "3", "displayValue": "Small Integer (No decimals)"},
    {"value": "4", "displayValue": "Decimal number"},
    {"value": "5", "displayValue": "Large Decimal Number"},
    {"value": "6", "displayValue": "Currency"}
  ];

export class PropertyTypeParameter {
  value: string;
  displayValue: string;
}
